import Cwe from './models/Cwe'
import { loadCwe } from '@/api/super'

export default {

  namespaced: true,

  state: {
    cwe: new Cwe()
  },

  mutations: {
    ...Cwe.mutations()
  },

  actions: {
    loadCwe: ({commit}, cweId) => new Promise((resolve, reject) => {
      loadCwe(cweId, ({data}) => {
        commit('setCwe', data)
        resolve()
      }, reject)
    })
  },

  getters: {
    cwe: state => state.cwe
  }

}